import React from "react";
import './AboutSection.css';
import tnFlag from "../assets/flags/Flag_of_Tunisia.svg";
import germanyFlag from "../assets/flags/Flag_of_Germany.svg";
import { useTranslation } from 'react-i18next';
function AboutSection() {
  const { t } = useTranslation();
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-left">
          <div className="country-card tunisia">
            <img src={tnFlag} alt="Tunisia Flag" className="flag" />
            <h3>{t('about_tunisia')}</h3>
            <div className="country-stats">
              <div className="stat">
                <span className="stat-number">26 680</span>
                <span className="stat-label">infirmiers</span>
              </div>
              <div className="stat">
                <span className="stat-number">+ 1 500</span>
                <span className="stat-label">{t('about_tn_yearly')}</span>
              </div>
            </div>
            <ul className="country-features">
              <li>✓ {t('about_tn_feature1')}</li>
              <li>✓ {t('about_tn_feature2')}</li>
              <li>✓ {t('about_tn_feature3')}</li>
            </ul>
          </div>
        </div>

        <div className="about-middle">
          <div className="bridge-visual">
            <div className="connection-line">
              <div className="pulse-dot start"></div>
              <div className="pulse-dot middle"></div>
              <div className="pulse-dot end"></div>
            </div>
            <div className="agency-card">
              <div className="agency-logo">
                <span className="logo-text">ProConnet</span>
              </div>
              <div className="agency-tagline">{t('about_tagline')}</div>

            </div>
          </div>
        </div>

        <div className="about-right">
          <div className="country-card germany">
            <img src={germanyFlag} alt="Germany Flag" className="flag" />
            <h3>{t('about_germany')}</h3>
            <div className="country-stats">
              <div className="stat">
                <span className="stat-number negative">-120 000</span>
                <span className="stat-label">{t('about_de_shortage')}</span>
              </div>
              <div className="stat">
                <span className="stat-number">€45k+</span>
                <span className="stat-label">{t('about_de_salary')}</span>
              </div>
            </div>
            <ul className="country-features">
              <li>✓ {t('about_de_feature1')}</li>
              <li>✓ {t('about_de_feature2')}</li>
              <li>✓ {t('about_de_feature3')}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
